import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dropdown } from 'common-components'
import { FormGroup } from 'reactstrap'
import { getPerfectLifeOptionsPlans, getSelectCampaignPlan } from '../selectors'
import { selectPerfectLifePlan } from '../../actions'

const BasicPlanSelection = ({ perfectLifeOptionsPlans, selectedPerfectLifePlans, selectPerfectLifePlan }) => {
  return (
    <FormGroup className={'basic-plan-selection item basic'}>
      <div className="form-group-title">
        <span className="form-group-title-text">สัญญาหลัก</span>
      </div>
      <div className="options option-labels">
        <label>เลือกแผน</label>
      </div>
      <Dropdown
        className="basic-plan form-control"
        options={perfectLifeOptionsPlans}
        onChange={(planCode) => {
          selectPerfectLifePlan(planCode)
        }}
        value={selectedPerfectLifePlans}
      />
    </FormGroup>
  )
}

const mapStateToProps = (state) => ({
  perfectLifeOptionsPlans: getPerfectLifeOptionsPlans(state),
  selectedPerfectLifePlans: getSelectCampaignPlan(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectPerfectLifePlan: bindActionCreators(selectPerfectLifePlan, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BasicPlanSelection)
